import { Injectable, HostListener } from '@angular/core';
import { ScreenSize } from '@core/enums/screen-service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  private screenSizeSubject = new Subject<string>();
  screenSize$ = this.screenSizeSubject.asObservable();

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.emitScreenSize();
  }

  getScreenSize(): string {
    const width = window.innerWidth;

    return (width >= 768) ? ScreenSize.Large : ScreenSize.Small;
  }

  private emitScreenSize(): void {
    const screenSize = this.getScreenSize();
    this.screenSizeSubject.next(screenSize);
  }
}
